import { copyFor } from 'config';

const getCopy = copyFor('solar.voiceSupportCard');

interface SupportCopy {
  title: string;
  paragraph: string;
}

interface Props {
  isDefault: boolean;
  numberOfSubmissions: number;
  state: string;
  stateAbbreviation: string;
}

export const getSupportCopy = ({
  isDefault,
  numberOfSubmissions,
  state,
  stateAbbreviation,
}: Props): SupportCopy => {
  const defaultTitle = getCopy('default.title', { state });
  const nonDefaultTitle = getCopy('nonDefault.title', { state });
  if (isDefault && numberOfSubmissions < 10) {
    return {
      paragraph: getCopy('default.paragraph.under10'),
      title: defaultTitle,
    };
  } else if (isDefault) {
    return {
      paragraph: getCopy('default.paragraph.over9', {
        numberOfSubmissions,
        stateAbbreviation,
      }),
      title: defaultTitle,
    };
  } else if (numberOfSubmissions < 10) {
    return {
      paragraph: getCopy('nonDefault.paragraph.under10'),
      title: nonDefaultTitle,
    };
  } else {
    return {
      paragraph: getCopy('nonDefault.paragraph.over9', {
        numberOfSubmissions,
        stateAbbreviation,
      }),
      title: nonDefaultTitle,
    };
  }
};
